import { useIsSellerOnFeatureGatedPlan } from './use-is-seller-on-feature-gated-plan';
import { usePlanFeatureGate } from './use-plan-feature-gate';
import { Features } from '../constants/features';

/** @typedef {import('../prop-types/intl-types').MessageDescriptor} MessageDescriptor */

/**
 * Returns feature gate objects for both basic and printer packing slips customization
 * @returns {{
 *   basicPackingSlipsCustomizedFeature: boolean,
 *   printerPackingSlipsCustomizedFeature: boolean,
 *   disabledMessage?: MessageDescriptor
 * }}
 */
export const usePackingSlipsCustomizedFeatureGate = () => {
  const { isFeatureEnabled, disabledMessage } = usePlanFeatureGate(Features.PackingSlipsCustomized);
  const isSellerOnFeatureGatedPlan = useIsSellerOnFeatureGatedPlan();
  // we are only locking the printing setup portion of the feature for sellers on the new line-up plan profile
  if (isSellerOnFeatureGatedPlan) {
    return {
      basicPackingSlipsCustomizedFeature: isFeatureEnabled,
      printerPackingSlipsCustomizedFeature: isFeatureEnabled,
      disabledMessage,
    };
  }
  return {
    basicPackingSlipsCustomizedFeature: isFeatureEnabled,
    printerPackingSlipsCustomizedFeature: true,
    disabledMessage,
  };
};
